import React, {Component} from 'react'
import PropTypes from 'prop-types'
import bulkGenerateTemplate from '../actions/bulkGenerateTemplate'
import {Button, Dropdown, Icon, Menu} from 'antd'
import bulkOnHold from '../actions/bulkOnHold'
import bulkUndoOnHold from '../actions/bulkUndoOnHold'
import BulkCancel from '../actions/BulkCancel'
import bulkSyncDesignsAndGenerate from '../actions/bulkSyncDesignsAndGenerate'
import bulkMarkUnprinted from '../actions/bulkMarkUnprinted'
import bulkMarkAsDone from "../actions/bulkMarkAsDone"
import bulkMarkArchiveOrders from "../actions/bulkMarkArchiveOrders"

class OrdersAllSelection extends Component {
    state = {
        action: '',
    }

    _renderAction = () => {
        const {selectedOrders, onFetchOrders, onResetSelectOrder} = this.props

        switch (this.state.action) {
            case 'bulkIdsAction5':
                return <BulkCancel onResetAction={this._resetAction} selectedOrders={selectedOrders} onFetchOrders={onFetchOrders} onResetSelectOrder={onResetSelectOrder}/>
            default:
                return ''
        }
    }

    _handleChange = e => {
        const {checked} = e.target

        this.props.onToggleSelectAll(checked)
    }

    _handleMenuClick = ({key}) => {
        const {selectedOrders, onFetchOrders, onResetSelectOrder} = this.props

        if ('bulkIdsAction1' === key) {
            bulkGenerateTemplate(selectedOrders, onFetchOrders, onResetSelectOrder)
        } else if ('bulkIdsAction2' === key) {
            bulkOnHold(selectedOrders, onFetchOrders, onResetSelectOrder)
        } else if ('bulkIdsAction3' === key) {
            bulkUndoOnHold(selectedOrders, onFetchOrders, onResetSelectOrder)
        } else if ('bulkIdsAction4' === key) {
            bulkSyncDesignsAndGenerate(selectedOrders, onFetchOrders, onResetSelectOrder)
        } else if ('bulkIdsAction6' === key) {
            bulkMarkUnprinted(selectedOrders, onFetchOrders, onResetSelectOrder)
        } else if ('bulkIdsAction7' === key) {
            bulkMarkAsDone(selectedOrders, onFetchOrders, onResetSelectOrder)
        } else if ('bulkIdsAction8' === key) {
            bulkMarkArchiveOrders(selectedOrders, onFetchOrders, onResetSelectOrder)
        }

        this.setState({
            action: key,
        })
    }

    _resetAction = () => {
        this.setState({
            action: '',
        })
    }

    _menu = (
        <Menu onClick={this._handleMenuClick}>
            <Menu.Item key='bulkIdsAction1'>Tạo file in</Menu.Item>
            <Menu.Item key='bulkIdsAction4'>Đồng bộ designs và tạo files in</Menu.Item>
            <Menu.Divider/>
            <Menu.Item key='bulkIdsAction2'>Đánh dấu tạm dừng</Menu.Item>
            <Menu.Item key='bulkIdsAction3'>Đánh dấu tiếp tục</Menu.Item>
            <Menu.Item key='bulkIdsAction7'>Đánh dấu đã xong</Menu.Item>
            <Menu.Divider/>
            <Menu.Item key='bulkIdsAction5'><span className='text-danger'>Hủy đơn</span></Menu.Item>
        </Menu>
    )

    render() {
        const {isChecked, selectedOrders} = this.props
        const action = this._renderAction()

        return (
            <th className='OrdersAllSelection position-relative'>
                <div className='custom-control custom-checkbox'>
                    <input type='checkbox' id='orderAllSelection' className='custom-control-input' checked={isChecked}
                           onChange={this._handleChange}/>
                    <label htmlFor='orderAllSelection' className='custom-control-label'/>
                </div>

                {
                    selectedOrders.length > 0 &&
                    <div className='MenuActions position-absolute'>
                        <Dropdown overlay={this._menu} trigger={['click']}>
                            <Button>Actions <Icon type='down'/></Button>
                        </Dropdown>
                        <div className='ml-3 font-weight-300'>
                            <span>Bạn đã chọn <strong>{selectedOrders.length}</strong> items.</span>
                        </div>

                        {action}
                    </div>
                }
            </th>
        )
    }
}

OrdersAllSelection.propTypes = {
    isChecked: PropTypes.bool.isRequired,
    selectedOrders: PropTypes.array.isRequired,
    onToggleSelectAll: PropTypes.func.isRequired,
    onFetchOrders: PropTypes.func.isRequired,
    onResetSelectOrder: PropTypes.func
}

export default OrdersAllSelection
